export default {
	"distribution": {
		"distribution": "แจกจ่าย",
		"cancelDistribution": "ยกเลิกการมอบหมาย"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/distribution/distribution.js